export default __webpack_public_path__ + "static/transport-0fd458e700e02f50cf97a8ec658037b4.jpg";